module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 12,
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10,
      "align": "center"
    }
  }, [(_vm.isSiteManager && _vm.allowAssign) ? _c('select-organisation', {
    attrs: {
      "label": "",
      "full-object": "",
      "no-form": ""
    },
    model: {
      value: (_vm.org),
      callback: function($$v) {
        _vm.org = $$v
      },
      expression: "org"
    }
  }) : _c('div', [_vm._v("\n        Org: "), _c('b', [_vm._v(_vm._s(_vm.taskData.organisation.name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "align": "center"
    }
  }, [(_vm.allowAssign && _vm.isSiteManager) ? _c('select-contact', {
    attrs: {
      "label": "",
      "org-id": _vm.taskData.organisation_id,
      "placeholder": "Attended by...",
      "disabled": !_vm.allowAssign,
      "full-object": "",
      "no-form": ""
    },
    model: {
      value: (_vm.contact),
      callback: function($$v) {
        _vm.contact = $$v
      },
      expression: "contact"
    }
  }) : _c('div', [_vm._v("\n        Assigned "), _c('b', [_vm._v(_vm._s(_vm.taskData.contact.name))]), (_vm.taskData.contact.phone) ? _c('span', [_vm._v(" " + _vm._s(_vm.taskData.contact.phone))]) : _vm._e(), _vm._v(" "), (_vm.taskData.contact.email) ? _c('span', {
    staticClass: "detail-text"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.taskData.contact.email +
        '?subject=RE: Site [' + _vm.taskData.site.siteName + '] for Task: ' + _vm.taskData.name +
        (_vm.taskData.started_at ? ' (started ' + this.formatFriendlyDate(_vm.taskData.started_at) + ')' : '')
    }
  }, [_vm._v(_vm._s(_vm.taskData.contact.email))])]) : _vm._e()])], 1), _vm._v(" "), (_vm.isSiteManager) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(_vm.isSiteManager) ? _c('el-button', {
    attrs: {
      "type": _vm.allowAssign ? 'success' : 'text',
      "icon": _vm.allowAssign ? 'fa fa-check' : 'fa fa-edit',
      "disabled": _vm.isFinished
    },
    on: {
      "click": _vm.onSelect
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-797ae1ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/site/OrgContactAssign.vue
// module id = 1649
// module chunks = 0